import styled from "styled-components";

export const Container = styled.div`
    padding: 40px 20px;
    background: white;
    border-radius: 8px;
`